<app-page [onlyContent]="true" [simpleTopBar]="globalVars.isMobile()" title="Create an NFT">
  <app-mint-nft-modal></app-mint-nft-modal>
</app-page>
